// extracted by mini-css-extract-plugin
module.exports = {"container":"Dpzvup0dB4uGrWCQ45Gpy"};